export default __webpack_public_path__ + "static/media/LOGO Q2-2.cde2ac84.png";